import Page from "components/Page";
import { Props } from "./WorkflowNotifications";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const WorkflowNotifications = lazyWithRetry(() =>
  import("./WorkflowNotifications")
);

export default (props: Props) => (
  <Page>
    <WorkflowNotifications {...props} />
  </Page>
);
